.container {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1, 8px);
  padding: var(--tuna-spacing-2, 16px) var(--tuna-spacing-2, 16px) var(--tuna-spacing-1, 8px);
  background: var(--agent-accent-header-bg, transparent);
  border-bottom: 1px solid var(--tuna-palette-divider, rgba(0, 0, 0, 0.12));
}

.avatar {
  background-color: var(--agent-accent);
  color: var(--tuna-content-onColor);
  width: 28px;
  height: 28px;
}

.text {
  min-width: 0;
  flex: 1;
}

/* Trailing, after the identity: acts on the agent in view (Joni's Personalize spec §1) */
.personalize {
  flex-shrink: 0;
  align-self: center;
}

/* "Following your band's notes." — quiet, under the role line (Joni's Personalize spec §4) */
.notes {
  display: block;
  font-size: var(--tuna-typography-fontSize-sm);
  color: var(--tuna-content-muted);
  text-align: start;
}

.name {
  color: var(--tuna-content-primary);
}

.roleLine {
  color: var(--tuna-content-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
